module.exports = __webpack_public_path__ + "images/pages/patient-profiles/patient-4.png";